module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Copyright-rw exclude-print-rw page-open-auto-rw",
    attrs: {
      "epub:type": "frontmatter copyright-page",
      "id": "Copyright2"
    }
  }, [_c('div', {
    staticClass: "block-rw copyright-rw",
    attrs: {
      "id": "copyright2"
    }
  }, [_c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1579"
    }
  }, [_c('span', [_vm._v("The characters and events in this book are fictitious. Any similarity to real persons, living or dead, is coincidental and not intended by the author.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1580"
    }
  }, [_c('span', [_vm._v("Copyright © 2016 by Malcolm Mackay"), _c('br'), _vm._v("\nCover design by Oliver Munday; photograph by Vincent Besnault/Getty Images "), _c('br'), _vm._v("\nCover copyright © 2018 Hachette Book Group, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1581"
    }
  }, [_c('span', [_vm._v("Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1582"
    }
  }, [_c('span', [_vm._v("The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1583"
    }
  }, [_c('span', [_vm._v("Mulholland Books / Little, Brown and Company"), _c('br'), _vm._v("\nHachette Book Group"), _c('br'), _vm._v("\n1290 Avenue of the Americas, New York, NY 10104"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mulhollandbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("mulhollandbooks.com")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.twitter.com/mulhollandbooks",
      "target": "_blank"
    }
  }, [_vm._v("twitter.com/mulhollandbooks")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.facebook.com/mulhollandbooks",
      "target": "_blank"
    }
  }, [_vm._v("facebook.com/mulhollandbooks")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1584"
    }
  }, [_c('span', [_vm._v("First US ebook edition: May 2018")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1585"
    }
  }, [_c('span', [_vm._v("Mulholland Books is an imprint of Little, Brown and Company, a division of Hachette Book Group, Inc. The Mulholland Books name and logo are trademarks of Hachette Book Group, Inc. ")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1586"
    }
  }, [_c('span', [_vm._v("The publisher is not responsible for websites (or their content) that are not owned by the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1587"
    }
  }, [_c('span', [_vm._v("The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to hachettespeakersbureau.com or call (866) 376-6591.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1588"
    }
  }, [_c('span', [_vm._v("ISBN 978-0-316-55605-7")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p1589"
    }
  }, [_c('span', [_vm._v("E3-20180306-DA-PC")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fbff4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s002-Copyright-01.vue
// module id = 63
// module chunks = 0